import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import {
  Case,
  Default,
  Switch,
} from "../components/common/ConditionalRendering";
import Loader from "../components/common/Loader";
import MobileFullScreenError from "../components/common/MobileFullScreenError";
import { logToFirebase } from "../helperFunctions";
import useAuthenticateJWT from "../hooks/useAuthenticateJWT";
import useMobileView from "../hooks/useMobileView";
import DesktopLayout from "../layout/DashboardLayout";
import MobileLayout from "../layout/MobileLayout";
import { AUTH_ERROR } from "../Store/Actions/types";
import FeatureEnabledRoute from "./FeatureEnabledRoute";

const PrivateRoute = () => {
  const dispatch = useDispatch();
  const isMobileView = useMobileView();
  const Layout = isMobileView ? MobileLayout : DesktopLayout;

  const { authLoading, authError, user } = useSelector(state => ({
    user: state.auth?.user,
    authLoading: state.auth?.loading,
    authError: state.auth?.error,
  }));

  const { isJWTPresent } = useAuthenticateJWT();

  useEffect(() => {
    dispatch({ type: AUTH_ERROR, payload: "" });
    logToFirebase("PrivateRoute mounted");
  }, [dispatch]);

  const showError = isMobileView && !!authError;
  const showLoading = isMobileView && (isJWTPresent || authLoading);

  return (
    <Switch>
      <Case condition={showError}>
        <MobileFullScreenError error={authError} />
      </Case>

      <Case condition={showLoading}>
        <Loader wrapperHeight="100vh" />
      </Case>

      <Case condition={!user}>
        <Navigate to="/login" replace />
      </Case>

      <Default>
        <FeatureEnabledRoute>
          <Layout>
            <Outlet />
          </Layout>
        </FeatureEnabledRoute>
      </Default>
    </Switch>
  );
};

export default PrivateRoute;
